import { Link } from 'react-router-dom';

import { ROUTES } from '../routes/paths';

export function NotFoundPage() {
  return (
    <div>
      <h1>Page not found</h1>
      <p>The page you requested does not exist or may have been moved.</p>
      <p>
        <Link to={ROUTES.home}>Return to the home page</Link>
      </p>
    </div>
  );
}
